import { RUGBY_URBA_12_MATCHES } from '../../vs-unified/data/matches/matches-urba-12';
import { SPORT_CONFIG } from '../../vs-unified/data/sports';

const getDynamicOptionsByTeam = (fieldKey: string, formData: any, baseOptions?: any): any[] | undefined => {
  const { team1 } = formData;

  const filteredTeams = SPORT_CONFIG.rugby.teams;

  // Opciones de team1
  if (fieldKey === 'team1') {
    return filteredTeams.map(team => ({
      value: team.value,
      label: team.label
    }));
  }

  // Opciones de team2 (excluir team1)
  if (fieldKey === 'team2' && team1) {
    return filteredTeams
      .filter(team => team.value !== team1)
      .map(team => ({
        value: team.value,
        label: team.label
      }));
  }

  return baseOptions;
};

// Usar en caso de que filtremos la miniatura por partidos del torneo URBA 12
const getDynamicOptionsByMatch = (fieldKey: string, formData: any, baseOptions?: any): any[] | undefined => {
  const { round, team1 } = formData;

  // Filtrar partidos por round
  const filteredMatches = round ? RUGBY_URBA_12_MATCHES.filter(m => m.round === round) : RUGBY_URBA_12_MATCHES;

  // Opciones de team1
  if (fieldKey === 'team1') {
    const uniqueTeams = Array.from(new Set(filteredMatches.map(m => m.team1)));
    return uniqueTeams.map(team => ({
      value: team,
      label: team.toUpperCase()
    }));
  }

  // Opciones de team2 (solo oponente de team1)
  if (fieldKey === 'team2' && team1) {
    const match = filteredMatches.find(m => m.team1 === team1);
    if (match) {
      return [
        {
          value: match.team2,
          label: match.team2.toUpperCase()
        }
      ];
    }
  }

  return baseOptions;
};

export const getDynamicOptions = (fieldKey: string, formData: any, baseOptions?: any): any[] | undefined => {
  return getDynamicOptionsByTeam(fieldKey, formData, baseOptions);
};
